<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="progress-container">
    <div class="progress-track">
      <div class="progress-value" :style="{ width: `${valuePercentage}%` }"></div>
    </div>
    <input
      type="range"
      :id="id"
      :value="modelValue"
      :min="min"
      :max="max"
      :step="step"
      class="progress-slider"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  emits: ["update:modelValue", "change"],
  computed: {
    valuePercentage() {
      return ((this.modelValue - this.min) / (this.max - this.min)) * 100;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-container {
  position: relative;
  width: 100%;
  height: 6px;
  margin: 1rem 0;
}

.progress-track {
  position: absolute;
  width: 100%;
  height: 6px;
  background-color: #ffffff; /* Unfilled portion */
  border-radius: 3px;
  top: 0;
  left: 0;
}

.progress-value {
  height: 100%;
  background-color: #256b64; /* Filled portion */
  border-radius: 3px;
  transition: width 0.2s;
}

.progress-slider {
  width: 100%;
  height: 100%;
  appearance: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  position: absolute; /* Changed from absolute to relative */
  top: -2px;
  left: 0;
  /* Removed z-index: 1 */
}

.progress-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: #256b64; /* Match filled color */
  border: none; /* Remove white border to match image */
  border-radius: 20%;
  cursor: pointer;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  // transition: background 0.2s;
}

.progress-slider::-webkit-slider-runnable-track {
  background: transparent; /* Ensure the track doesn't interfere */
}
</style>